var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyberpunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#120458"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 20v-5l-7-5h-10l-7 5v5l2 10 3 5h14l3-5z",
    fill: "#00f6ff",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10h-10l-1 5h12z",
    fill: "#ff00a0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15v5h10v-5z",
    fill: "#00f6ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 10,
    height: 10,
    fill: "#ff00a0",
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 6,
    height: 2,
    fill: "#00f6ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 6,
    height: 2,
    fill: "#00f6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17h2v16h-2zm10 0h2v16h-2z",
    fill: "#120458"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19h12v2h-12zm0 10h12v2h-12z",
    fill: "#120458"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 1,
    fill: "#ff00a0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 1,
    fill: "#ff00a0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 32,
    r: 1,
    fill: "#ff00a0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 1,
    fill: "#ff00a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberpunk);
export default __webpack_public_path__ + "static/media/cyberpunk.069aac0b9fb23d0f5771cc96290247ab.svg";
export { ForwardRef as ReactComponent };